module.exports = __webpack_public_path__ + "media/cover_2000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/cover_2000.jpg
// module id = 19
// module chunks = 0